import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'
import {
  LinkOnlyRedemptionBlockFragment,
  MultipleCodesRedemptionBlockFragment,
  Redemption,
  SingleCodeRedemptionBlockFragment,
} from '../../redemptions'

export const FeaturedOfferBlockFragment: BlockFragment = {
  name: 'featuredOffer',
  fragment: gql`
    fragment featuredOffer on FeaturedOffer {
      id
      blockName
      blockType
      withBackgroundImage
      showEndTime
      offer {
        id
        name
        description
        tag
        featuredImage {
          id
          url
          alt
        }
        expiresAt
        slug
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on FeaturedOffer {
      id
      blockName
      blockType
      withBackgroundImage
      showEndTime
      offer {
        id
        name
        description
        tag
        featuredImage {
          id
          url
          alt
        }
        expiresAt
        slug
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const FeaturedOfferBlockType = 'featuredOffer'

export const canRenderFeaturedOfferBlock = (block: FeaturedOfferBlock) => {
  if (!block.offer) {
    return false
  }

  return true
}

export interface FeaturedOfferBlock extends BaseOfferBlock {
  blockType: typeof FeaturedOfferBlockType
  withBackgroundImage?: boolean
  showEndTime?: boolean
  imagePriority?: boolean
  offer: {
    id: string
    name: string
    description?: string
    tag?: string
    featuredImage: {
      url: string
      alt: string
    }
    expiresAt?: string
    slug: string
    brand: {
      slug: string
      logo: {
        url: string
        alt: string
      }
    }
    offerLinkLabel?: string
    redeemInList: boolean
    canRedeem: boolean
    redemptions: Redemption[]
    isBookmarked: boolean
  }

  // Extra props
  isEmbedded?: boolean
}
